module.exports = __webpack_public_path__ + "img/st-barts.d421045d.png";